import { DatePipe, CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalAction } from '../../modals/modal-actions/modal-action.interface';
import { CourseStatus } from '../../models/enums/course-status.enum';
import { Category } from '../../models/interfaces/category.interface';
import { Course } from '../../models/interfaces/course.interface';
import { ModalActionsComponent } from '../../modals/modal-actions/modal-actions.component';
import { Sorts } from '../../services/pagination/models/typies/sorts.type';
import { IconComponent } from '../icon/icon.component';
import { ListContainerComponent } from '../list-container/list-container.component';
import { SortIconComponent } from '../sort-icon/sort-icon.component';
import { CourseCategoryTagComponent } from '../course-category-tag/course-category-tag.component';

@Component({
  selector: 'l-course-table',
  standalone: true,
  imports: [
    CommonModule,
    DatePipe,
    IconComponent,
    ListContainerComponent,
    ModalActionsComponent,
    SortIconComponent,
    CourseCategoryTagComponent,
  ],
  templateUrl: './course-table.component.html',
})
export class CourseTableComponent {

  @Input({ required: true })
  public data: Course[] = [];

  @Input({ required: true })
  public isLoading = false;

  @Input({ required: true })
  public getRowActions!: (course: Course) => ModalAction[];

  @Input()
  public limit = 10;

  @Input()
  public page = 1;

  @Input()
  public total = 0;

  @Input()
  public sort?: Sorts;

  @Input()
  public categories: Category[] = [];

  @Output()
  public pageChange = new EventEmitter<number>();

  @Output()
  public sortChange = new EventEmitter<Sorts>();

  public getStatusLabel(status: CourseStatus): string {
    if (status === CourseStatus.ACTIVE) {
      return 'Ativo';
    }

    if (status === CourseStatus.INACTIVE) {
      return 'Inativo';
    }

    if (status === CourseStatus.DELETED) {
      return 'Excluído';
    }

    return 'Rascunho';
  }

  public getStatusClass(status: CourseStatus): string {
    if (status === CourseStatus.ACTIVE) {
      return 'bg-lSuccess text-lGray900 light:text-black/80';
    }

    if (status === CourseStatus.INACTIVE) {
      return 'bg-lGray600 text-lWhite light:text-white';
    }

    return 'bg-lWarning text-lGray900 light:text-white';
  }

  public resolveCategory(course: Course): Category | undefined {
    if (course.category?.name) {
      return course.category;
    }

    if (!course.categoryId) {
      return undefined;
    }

    return this.categories.find((category) => category.id === course.categoryId);
  }

  public getCategoryTextColor(color?: string): string {
    if (!color) {
      return '#1E2030';
    }

    const lightTextColors = new Set(['#6D4BFF', '#33AAFF', '#8D56F4', '#FF4FA0']);
    return lightTextColors.has(color.toUpperCase()) ? '#E7E1FF' : '#3B3314';
  }

}
